<button
  id="deleteModal1"
  type="button"
  data-toggle="modal"
  data-target="#deleteDeviceModel1"
  [hidden]="true"
  aria-hidden="true"
  class="sr-only">
</button>
<button
  id="deleteModal2"
  type="button"
  data-toggle="modal"
  data-target="#deleteDeviceModel2"
  [hidden]="true"
  aria-hidden="true"
  class="sr-only">
</button>
<!-- BEGIN MODAL DELETE -->
<div id="{{modalId}}" class="modal effect-flip-horizontal fade cdm-modal" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-dialog-centered cdm-dialog" role="document">
    <div class="modal-content cdm-content">
      <div class="modal-body cdm-body p-0">
        <div class="cdm">
          <header class="cdm__header">
            <div class="cdm__title-wrap">
              <span class="cdm__icon" aria-hidden="true">
                <i class="fa fa-exclamation-triangle"></i>
              </span>
              <h5 class="cdm__title">{{ title }}</h5>
            </div>
            <button
              type="button"
              id="{{modalCloseId}}"
              (click)="cancelConfirm()"
              #btnClose
              class="cdm__close"
              data-dismiss="modal"
              aria-label="Close">
              <i class="fa fa-times" aria-hidden="true"></i>
            </button>
          </header>

          <div class="cdm__content">
            <h4 class="cdm__question">Are you sure?</h4>
            @if (!displayMessage) {
              <p class="cdm__message">
                This action cannot be undone. Please type “confirm” in the box below to continue.
              </p>
            }
            @if (displayMessage) {
              <p class="cdm__message">{{ displayMessage }}</p>
            }

            @if (!hideInputconfirm) {
              <div class="cdm__input-wrap">
                <input
                  type="text"
                  name="confirm"
                  id="confirm"
                  class="form-control cdm__input"
                  [(ngModel)]="confirmText"
                  autocomplete="off"
                  tabindex="2"
                  placeholder="Type confirm"
                  (keyup)="matchCriteria()"
                  required
                />
              </div>
            }
          </div>

          <div class="cdm__actions">
            <button
              #btnClose
              type="button"
              class="cdm__btn cdm__btn--cancel"
              data-dismiss="modal"
              (click)="cancelConfirm()">
              Cancel
            </button>
            @if (!hideInputconfirm) {
              <button
                [disabled]="disableBtn || !confirmed"
                type="button"
                (click)="confirmDelete()"
                class="cdm__btn cdm__btn--confirm cdm__btn--{{ type }}">
                @if (primaryAction) {
                  <span>Confirm</span>
                }
                @if (!primaryAction) {
                  <span>{{ displayText }}</span>
                }
              </button>
            }
            @if (hideInputconfirm) {
              <button
                [disabled]="disableBtn"
                type="button"
                (click)="confirmDelete()"
                class="cdm__btn cdm__btn--confirm cdm__btn--{{ type }}">
                @if (primaryAction) {
                  <span>Confirm</span>
                }
                @if (!primaryAction) {
                  <span>{{ displayText }}</span>
                }
              </button>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- END MODAL DELETE -->
